import { Fragment, useContext } from 'react'
import { MainContext } from '../../../../context/MainContext'

const CrossSVG = () => (
  <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M6.00016 6.61461L7.79275 8.40734C7.87354 8.48803 7.97509 8.52935 8.09739 8.53129C8.2196 8.53314 8.323 8.49182 8.40758 8.40734C8.49207 8.32275 8.53431 8.22028 8.53431 8.09992C8.53431 7.97956 8.49207 7.87709 8.40758 7.7925L6.61485 5.99992L8.40758 4.20734C8.48827 4.12654 8.52959 4.025 8.53154 3.90269C8.53339 3.78048 8.49207 3.67709 8.40758 3.5925C8.323 3.50802 8.22052 3.46577 8.10016 3.46577C7.9798 3.46577 7.87733 3.50802 7.79275 3.5925L6.00016 5.38523L4.20758 3.5925C4.12679 3.51181 4.02524 3.47049 3.90293 3.46854C3.78073 3.4667 3.67733 3.50802 3.59275 3.5925C3.50826 3.67709 3.46602 3.77956 3.46602 3.89992C3.46602 4.02028 3.50826 4.12275 3.59275 4.20734L5.38548 5.99992L3.59275 7.7925C3.51205 7.87329 3.47073 7.97484 3.46879 8.09715C3.46694 8.21936 3.50826 8.32275 3.59275 8.40734C3.67733 8.49182 3.7798 8.53407 3.90016 8.53407C4.02052 8.53407 4.123 8.49182 4.20758 8.40734L6.00016 6.61461ZM6.00118 11.5416C5.23468 11.5416 4.51422 11.3961 3.83979 11.1053C3.16536 10.8144 2.57872 10.4196 2.07987 9.92094C1.58102 9.42229 1.18606 8.83589 0.894975 8.16175C0.603989 7.48761 0.458496 6.76734 0.458496 6.00094C0.458496 5.23444 0.603941 4.51397 0.894829 3.83954C1.18572 3.16511 1.58049 2.57847 2.07914 2.07963C2.5778 1.58078 3.16419 1.18581 3.83833 0.894731C4.51247 0.603745 5.23274 0.458252 5.99914 0.458252C6.76564 0.458252 7.48611 0.603696 8.16054 0.894585C8.83497 1.18547 9.42161 1.58025 9.92046 2.0789C10.4193 2.57755 10.8143 3.16395 11.1054 3.83809C11.3963 4.51222 11.5418 5.2325 11.5418 5.9989C11.5418 6.7654 11.3964 7.48586 11.1055 8.16029C10.8146 8.83473 10.4198 9.42136 9.92118 9.92021C9.42253 10.4191 8.83614 10.814 8.162 11.1051C7.48786 11.3961 6.76759 11.5416 6.00118 11.5416ZM6.00016 10.6666C7.30294 10.6666 8.40641 10.2145 9.31058 9.31034C10.2147 8.40617 10.6668 7.3027 10.6668 5.99992C10.6668 4.69714 10.2147 3.59367 9.31058 2.6895C8.40641 1.78534 7.30294 1.33325 6.00016 1.33325C4.69739 1.33325 3.59391 1.78534 2.68975 2.6895C1.78558 3.59367 1.3335 4.69714 1.3335 5.99992C1.3335 7.3027 1.78558 8.40617 2.68975 9.31034C3.59391 10.2145 4.69739 10.6666 6.00016 10.6666Z' fill='#CF1B24' />
  </svg>
)

const CheckSVG = () => (
  <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M5.17227 7.2519L3.81718 5.89667C3.73639 5.81598 3.63484 5.77466 3.51254 5.77271C3.39033 5.77086 3.28693 5.81218 3.20235 5.89667C3.11786 5.98125 3.07562 6.08372 3.07562 6.20409C3.07562 6.32445 3.11786 6.42692 3.20235 6.5115L4.80316 8.11231C4.90865 8.2177 5.03168 8.2704 5.17227 8.2704C5.31285 8.2704 5.43589 8.2177 5.54137 8.11231L8.78675 4.86694C8.86744 4.78615 8.90876 4.6846 8.91071 4.56229C8.91255 4.44009 8.87123 4.33669 8.78675 4.25211C8.70216 4.16762 8.59969 4.12538 8.47933 4.12538C8.35897 4.12538 8.2565 4.16762 8.17191 4.25211L5.17227 7.2519ZM6.00118 11.5416C5.23468 11.5416 4.51422 11.3961 3.83979 11.1053C3.16536 10.8144 2.57872 10.4196 2.07987 9.92094C1.58102 9.42229 1.18606 8.83589 0.894975 8.16175C0.603989 7.48761 0.458496 6.76734 0.458496 6.00094C0.458496 5.23444 0.603941 4.51397 0.894829 3.83954C1.18572 3.16511 1.58049 2.57847 2.07914 2.07963C2.5778 1.58078 3.16419 1.18581 3.83833 0.894731C4.51247 0.603745 5.23274 0.458252 5.99914 0.458252C6.76564 0.458252 7.48611 0.603696 8.16054 0.894585C8.83497 1.18547 9.42161 1.58025 9.92046 2.0789C10.4193 2.57755 10.8143 3.16395 11.1054 3.83809C11.3963 4.51222 11.5418 5.2325 11.5418 5.9989C11.5418 6.7654 11.3964 7.48586 11.1055 8.16029C10.8146 8.83473 10.4198 9.42136 9.92118 9.92021C9.42253 10.4191 8.83614 10.814 8.162 11.1051C7.48786 11.3961 6.76759 11.5416 6.00118 11.5416ZM6.00016 10.6666C7.30294 10.6666 8.40641 10.2145 9.31058 9.31034C10.2147 8.40617 10.6668 7.3027 10.6668 5.99992C10.6668 4.69714 10.2147 3.59367 9.31058 2.6895C8.40641 1.78534 7.30294 1.33325 6.00016 1.33325C4.69739 1.33325 3.59391 1.78534 2.68975 2.6895C1.78558 3.59367 1.3335 4.69714 1.3335 5.99992C1.3335 7.3027 1.78558 8.40617 2.68975 9.31034C3.59391 10.2145 4.69739 10.6666 6.00016 10.6666Z' fill='#12641B' />
  </svg>
)

const VALIDATIONS = {
  minLength: 'Password validation Min length',
  hasUpperCase: 'Password validation Has uppercase',
  hasLowerCase: 'Password validation Has lowercase',
  hasNumber: 'Password validation Has number',
  firstNameOrLastName: 'Password validation First name or last name',
  spaceName: 'Password validation Space name',
  auravant: 'Password validation Auravant',
  passwordOrPass: 'Password validation Password or pass'
}

const COLORS = {
  red: 'rgba(207, 27, 36, 1)',
  green: 'rgba(18, 100, 27, 1)'
}

const Dialog = ({ validationResult, showDialog, t, position = 'top' }) => {
  const { workspace } = useContext(MainContext)
  const isPremium = !!workspace?.data?.premium
  
  return (
    <div className={`popUp ${position === 'bottom' ? 'popUp-bottom' : 'popUp-top'}`} style={{ display: showDialog ? 'block' : 'none' }}>
      <div className="popUpContainer">
        <span className="popUpTitle">{t('Password requirements')}</span>
        {
          Object.keys(validationResult).map((key) => {
            if (key === 'forbiddenTerms') {
              return (
                <Fragment key={key}>
                  {
                    Object.keys(validationResult[key])
                      .filter(term => !(term === 'auravant' && isPremium))
                      .map((term, index) => (
                        <div
                          key={index}
                          className="popUpText"
                          style={{ color: COLORS[validationResult[key][term] ? 'green' : 'red'] }}
                        >
                          {validationResult[key][term] ? <CheckSVG /> : <CrossSVG />}
                          <span>{t(VALIDATIONS[term])}</span>
                        </div>
                      ))
                  }
                </Fragment>
              );
            }
  
            return (
              <div
                key={key}
                className="popUpText"
                style={{ color: COLORS[validationResult[key] ? 'green' : 'red'] }}
              >
                {validationResult[key] ? <CheckSVG /> : <CrossSVG />}
                <span>{t(VALIDATIONS[key])}</span>
              </div>
            );
          })
        }
      </div>
    </div>
  );  
}

export default Dialog
